import { updateMember } from '@/services/member/member'
import { Member } from '@/services/member/member.model'
import { ModalForm } from '@ant-design/pro-form'
import { useRequest } from 'ahooks'
import { Form, Select } from 'antd'
import React, { memo, useContext } from 'react'
import { OrganizationContext } from '../..'
import { roleFilters } from '../Members'
const { Option } = Select

interface SettingMemberProps {
  trigger: JSX.Element
  member: Member.Info
  onSuccess?: () => void
}

export default memo<SettingMemberProps>(function SettingMember(props) {
  const [form] = Form.useForm()
  const { trigger, member, onSuccess, ...other } = props
  const orgData = useContext(OrganizationContext).orgData!
  const { run } = useRequest(updateMember, {
    manual: true,
    onSuccess: onSuccess
  })

  return (
    <ModalForm
      {...other}
      form={form}
      trigger={trigger}
      width={660}
      title='Setting'
      modalProps={{
        maskClosable: false
      }}
      onVisibleChange={(visible: boolean) => {
        visible &&
          form.setFieldsValue({
            ...member,
            groups: member.groups?.map((item) => item.id) || []
          })
      }}
      onFinish={async (values) => {
        run(orgData.id, member.memberId, values)
        return true
      }}
    >
      <Form.Item label='Account type' name='accountType'>
        <Select>
          {roleFilters.map((item) => (
            <Option value={item.value} key={item.value as number}>
              {item.text}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </ModalForm>
  )
})
